<template>
  <el-card shadow="never" class="input_card sbu">
    <div slot="header" v-if="title">
      <h4>{{ title }}</h4>
    </div>
    <div>
      <el-form :label-width="labelWidth" :label-position="labelPosition">
        <el-form-item
          :label="itmes.name"
          :class="'item' + (labelPosition == 'left' ? ' bottom' : '')"
          v-for="(itmes, index) in inputArr"
        >
          <template v-if="itmes.type == 'select'">
            <el-select
              v-model="itmes.value"
              placeholder
              clearable
              @change="change"
            >
              <el-option
                v-for="item in itmes.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
          <template v-else>
            <el-input
              v-model="itmes.value"
              @input="change"
              placeholder
            ></el-input>
          </template>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    title: String,
    labelWidth: {
      type: String,
      default: "80px",
    },
    labelPosition: {
      type: String,
      default: "left",
    },
    dataArr: Array,
  },
  data() {
    return {
      inputArr: [],
    };
  },
  methods: {
    change(e) {
      console.log(e);
      let data = {};
      for (let i = 0; i < this.inputArr.length; i++) {
        if (this.inputArr[i].value) {
          data[this.inputArr[i].apiName] = this.inputArr[i].value;
        }
      }
      this.$emit("change", data);
    },
  },
  mounted() {
    this.inputArr = [...this.dataArr];
  },
};
</script>
<style >
.input_card .el-form-item__label {
  font-weight: 600;
  padding: 0;
}
</style>
<style scoped>
.input_card {
  height: 100%;
}
.item {
  margin-bottom: 0;
}
.bottom {
  margin-bottom: 20px;
}
</style>